import { useSelector } from 'react-redux';

import { Subtitle } from '../../components/Subtitle';
import { getIsExperimentalLocation, getObjectInfo } from '../../selectors/objectInfo';
import { getReviewsConfig } from '../../utils/getReviewsConfig/getReviewsConfig';

export function SubtitleContainer() {
  const { reviewDescription } = useSelector(getObjectInfo);
  const isExperimentalLocation = useSelector(getIsExperimentalLocation);

  const reviewsConfig = getReviewsConfig();

  if (!reviewsConfig.SHOW_HEADER_SUMMARY) {
    return null;
  }

  return <Subtitle textList={reviewDescription} isExperimentalLocation={isExperimentalLocation} />;
}
